module.exports = __webpack_public_path__ + "web/img/grade3.c5261040.png";